import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import MasterData from '../../data/MasterData'

const RouteMapLineSelector = ({ lineName, type, themeName }) => {
  const intl = useIntl()
  const locale = intl.locale

  return (
    <ul className="c-LineTab">
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'for_tokyu' ? 'is_current' : ''}`}>
        <Link to={`/lines/for_tokyu/${type}`}>{MasterData.line(3)[`name_${locale}`]}</Link>
      </li>
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'main' ? 'is_current' : ''}`}>
        <Link to={`/lines/main/${type}`}>{MasterData.line(1)[`name_${locale}`]}</Link>
      </li>
      <li className={`c-LineTab-item c-LineTab-item--${themeName} ${lineName === 'izumino' ? 'is_current' : ''}`}>
        <Link to={`/lines/izumino/${type}`}>{MasterData.line(2)[`name_${locale}`]}</Link>
      </li>
    </ul>
  )
}

RouteMapLineSelector.propTypes = {
  lineName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
}

export default RouteMapLineSelector
